// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:19:46

export default {
  "id": "tower-wars-arena",
  "slug": "tower-wars-arena",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9e8bb81471124ff7a75ad120585b6022-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9e8bb81471124ff7a75ad120585b6022/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tower Wars Arena",
      "description": "Fight in the arena in a unique strategy with elements of real-time strategies and tower defense! Capture the center, increase your army and destroy enemy towers. Upgrade units and spells to legendary levels to achieve victory!",
      "instructions": "Controls:\n\nPlacing Units and Spells: Units and spells can be placed in the arena in two ways:\n1. Drag the selected unit or spell onto the arenas to place them in the desired position.\n2. Click on the unit or spell icon to select it, then select a place in the arena to place it.",
      "genres": [
        "Casual",
        "Strategy"
      ],
      "tags": [
        "defence",
        "monster",
        "tower"
      ]
    },
    "zh-CN": {
      "title": "塔战竞技场",
      "description": "在竞技场中以独特的策略战斗，融合实时策略和塔防元素！占领中心，扩充军队，摧毁敌方塔楼。升级单位和法术至传奇级别，以赢得胜利！",
      "instructions": "控制：\n\n放置单位和法术：单位和法术可以在竞技场中以两种方式放置：\n1. 将选定的单位或法术拖动到竞技场中，放置在期望的位置。\n2. 点击单位或法术图标以选择它，然后在竞技场中选择一个位置放置。",
      "genres": [
        "休闲",
        "策略"
      ],
      "tags": [
        "防御",
        "怪物",
        "塔"
      ]
    },
    "zh-TW": {
      "title": "塔戰場賽場",
      "description": "在鬥技場中以獨特的策略戰鬥，結合了即時戰略和塔防元素！佔領中心，增加你的軍隊並摧毀敵方塔樓。升級單位和魔法至傳說級別以達成勝利！",
      "instructions": "控制：\n\n放置單位與法術：單位與法術可以在戰場上以兩種方式放置：\n1. 拖曳選定的單位或法術到戰場上，將其放置在期望的位置。\n2. 點擊單位或法術圖示以選擇它，然後在戰場上選擇一個位置來放置它。",
      "genres": [
        "休闲",
        "策略"
      ],
      "tags": [
        "防禦",
        "怪物",
        "塔"
      ]
    },
    "zh-HK": {
      "title": "塔戰鬥場",
      "description": "在戰場上以獨特的策略作戰，結合了即時策略和防禦塔元素！佔領中心，增加你的軍隊並摧毀敵方塔樓。升級單位和法術至傳說級別以達成勝利！",
      "instructions": "控制：\n\n放置單位及魔法：單位及魔法可透過以下兩種方式放置在戰場上：\n1. 拖動選定的單位或魔法至戰場指定位置放置。\n2. 點擊單位或魔法圖示以選擇，然後選擇戰場中的位置放置。",
      "genres": [
        "隨意",
        "策略"
      ],
      "tags": [
        "防禦",
        "怪物",
        "塔"
      ]
    },
    "ja": {
      "title": "タワー・ウォーズ・アリーナ",
      "description": "アリーナでユニークな戦術を駆使し、リアルタイム戦略とタワードーフェンスの要素を取り入れた戦闘を行いましょう！中心を奪取し、軍隊を増強し、敵のタワーを破壊してください。ユニットと魔法を伝説のレベルにアップグレードして勝利を目指せ！",
      "instructions": "コントロール：\n\nユニットと魔法の配置：ユニットや魔法をアリーナに配置する方法は以下の2通りです：\n1. 選択したユニットまたは魔法をアリーナにドラッグして、希望する位置に配置します。\n2. ユニットまたは魔法のアイコンをクリックして選択し、アリーナ内の配置場所を選択します。",
      "genres": [
        "カジュアル",
        "ストラテジー"
      ],
      "tags": [
        "防衛",
        "モンスター",
        "タワー"
      ]
    },
    "ko": {
      "title": "타워 워즈 아레나",
      "description": "장애물 주변의 전장에서 독특한 전략을 사용하여 실시간 전략 및 타워 방어 요소를 결합하여 싸우세요! 중앙을 점령하고, 군대를 늘려 적의 타워를 파괴하세요. 유닛과 마법을 전설 수준으로 업그레이드하여 승리를 달성하세요!",
      "instructions": "컨트롤:\n\n유닛과 마법 배치: 유닛과 마법은 다음 두 가지 방식으로 아레나에 배치할 수 있습니다:\n1. 선택된 유닛이나 마법을 아레나에 드래그하여 원하는 위치에 배치합니다.\n2. 유닛이나 마법 아이콘을 클릭하여 선택한 후, 아레나에 배치할 위치를 선택합니다.",
      "genres": [
        "캐주얼",
        "전략"
      ],
      "tags": [
        "防衛",
        "몬스터",
        "타워"
      ]
    },
    "fr": {
      "title": "Arène des Guerres de Tours",
      "description": "Combattez dans l'arène avec une stratégie unique, intégrant des éléments de stratégie en temps réel et de défense de tours ! Capturez le centre, augmentez votre armée et détruisez les tours ennemies. Améliorez les unités et les sorts jusqu'aux niveaux légendaires pour obtenir la victoire !",
      "instructions": "Contrôles :\n\nPlacement d'unités et de sorts : Les unités et les sorts peuvent être placés dans l'arène de deux manières :\n1. Glisser l'unité ou le sort sélectionné sur l'arène pour les placer à la position désirée.\n2. Cliquez sur l'icône de l'unité ou du sort pour le sélectionner, puis choisissez un emplacement dans l'arène pour le placer.",
      "genres": [
        "Casual",
        "Stratégie"
      ],
      "tags": [
        "défense",
        "monstre",
        "tour"
      ]
    }
  }
};
